import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { CookieAccessor } from '../../../Customers/UserProfile/Components/CookiesConsent/CookieAccessor';
import { GoogleTagManager } from '../../../Tracking/GoogleTagManager/GoogleTagManager';

interface LogoutMenuSectionProps {
    isLoggedIn: boolean;
    hasActiveBankIdSession: boolean;
    logoutUrl: string;
}

export const LogoutMenuSection = (props: LogoutMenuSectionProps) => {
    const onLogOut = () => {
        CookieAccessor.deleteCookie('userID');
        CookieAccessor.deleteCookie('customerID');
        GoogleTagManager.addUserData(undefined, undefined);

        if (props.hasActiveBankIdSession) {
            window.dispatchEvent(new CustomEvent(EventNames.EComLogoutRequest));
        } else {
            window.location.href = props.logoutUrl;
        }
    };

    if (!props.isLoggedIn) {
        return null;
    }

    return (
        <div className="LogoutMenuSection">
            <div className="LogoutMenuSection__Divider" />
            <button className="LogoutMenuSection__Button" rel="nofollow noopener" onClick={onLogOut}>
                {getTranslation(keys['actionMenu.logOut'])}
            </button>
        </div>
    );
};
